import SectionProvider from '@builder/sections/SectionProvider'
import moment from 'moment'

export const name = 'Time Item 6'
export const group = 'time'
export const defaultOptions = {
  content: {
    time: {
      type: 'time-mod',
      display: true,
      time: moment(moment().format('YYYY-MM-DD') + ' ' + '23:59').valueOf(),
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      size: .8,
      sizing: {
        width: 6,
        counter: 3.5,
        divider: 1.5,
        subtitle: 0.8
      }
    }
  },
  customize: {
    layouts: null,
    style: {
      background: {
        background: '#E3E3E3',
        type: 'background-customs'
      },
      color: {
        type: 'color-customs',
        color: '#000000'
      },
      colorSubtitle: {
        color: '#929292',
        type: 'color-customs',
        label: 'Subtitle color'
      },
      dontShow: {
        type: 'checklist-customs',
        label: 'Don\'t Show',
        value: [],
        items: ['Days', 'Hours', 'Minutes', 'Seconds']
      },
      container: {
        type: 'container-customs',
        container: null
      },
      padding: {
        type: 'height-customs',
        sm: {
          top: 20,
          bottom: 20,
          left: 20,
          right: 20
        },
        md: {
          top: 20,
          bottom: 20,
          left: 20,
          right: 20
        },
        lg: {
          top: 20,
          bottom: 20,
          left: 20,
          right: 20
        }
      }
    }
  }
}

export const previews = {
  left: null,
  right: null,
  main: require('@builder/assets/svg/previews/time/main-6.png')
}

export default class Section extends SectionProvider {
  constructor (options = {}) {
    super('TimeItem6', options)

    this.name = name
    this.group = group
    this.defaultOptions = defaultOptions
  }
}
